import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { withNamespaces } from 'react-i18next';
import PropTypes from 'prop-types';

import { Spinner } from 'components';

@withNamespaces()
@observer
export class HiddenComments extends React.Component {
  render() {
    const { commentsConnection } = this.props;
    if (
      commentsConnection.totalLeft - commentsConnection.deletedComments <=
      0
    ) {
      return null;
    }
    if (commentsConnection.loading) {
      return <Spinner margin='30px auto 10px' />;
    }

    return (
      <React.Fragment>
        <Count>
          ...and <b>{commentsConnection.totalLeft}</b> other comments &nbsp;
          <LoadMore onClick={() => commentsConnection.loadMore()}>
            (load more)
          </LoadMore>
        </Count>
      </React.Fragment>
    );
  }
}

const Count = styled.p`
  margin: 30px auto 10px auto;
  text-align: center;
`;

const LoadMore = styled.span`
  color: ${props => props.theme.color.primary};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

HiddenComments.propTypes = {
  commentsConnection: PropTypes.object,
};
